module.exports = __webpack_public_path__ + "img/american-express.83e2b6d4.svg";